module.exports = __webpack_public_path__ + "img/20190725161239942.cc0c5d28.png";